import { action, observable, computed, makeObservable } from 'mobx';
import { SubmitState } from '../../../../commonv3/states/SubmitState';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { translateErrorMessage } from '../../../../commonv3/api/protocol';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { Subscription } from '../../../types/subscriptions';
import { SubscriptionsApis } from '../../../apis/subscriptions';
import { SubscriptionSuspensionCreatePageFormState } from './SubscriptionSuspensionCreatePageFormState';
import moment from 'moment-timezone';
import { V3Routes } from '../../../routes';
import { SurveyState } from './../../surveys/states/SurveyState';
import { SurveyKeysPlane } from './../../../../commonv3/types/surveys';

export class SubscriptionSuspensionCreatePageState {
  subscriptionCode: string;
  submitState = new SubmitState();
  subscription: RemoteResourceV3<Subscription> = RemoteResourceV3.loading();
  initialized = false;
  formState: SubscriptionSuspensionCreatePageFormState = new SubscriptionSuspensionCreatePageFormState();
  routerState = GlobalStatesV3.routing;
  surveyState = new SurveyState();
  surveyKey = SurveyKeysPlane.ADJOURNMENT;

  constructor() {
    makeObservable(this, {
      subscriptionCode: observable,
      submitState: observable,
      subscription: observable,
      initialized: observable,
      formState: observable,
      routerState: observable,
      startsAtOptions: computed,
      durationOptions: computed,
      submit: action.bound,
    });
  }

  async init(code: string) {
    this.initialized = false;
    this.subscriptionCode = code;
    const subscription = await updateRemoteResourceV3(
      this.subscription,
      (v) => (this.subscription = v),
      () => SubscriptionsApis.show(code)
    );
    if (subscription) {
      if (subscription.subscription_suspension) {
        this.routerState.push(V3Routes.plan());
      }
      this.formState.fields.duration.setDirtyValue(1);
      this.formState.fields.starts_at.setDirtyValue(moment(subscription.next_suspendable_date).format('YYYY/MM/DD'));
    }
    await this.surveyState.init(this.surveyKey);
    this.initialized = true;
  }

  get startsAtOptions(): { value: any; label: any }[] {
    const subscription = this.subscription.get();
    const next_suspendable_date = moment(subscription.next_suspendable_date);
    const next_suspendable_dates = [];
    for (let index = 0; index < 3; index++) {
      const suspendable_date = moment(next_suspendable_date)
        .add(index * subscription.duration_month, 'M')
        .format('YYYY/MM/DD');
      next_suspendable_dates.push({ value: suspendable_date, label: suspendable_date });
    }
    return next_suspendable_dates;
  }

  get durationOptions(): { value: number; label: any }[] {
    const duration_options = [];
    for (let index = 1; index <= 3; index++) {
      duration_options.push({ value: index, label: `${index}ヶ月` });
    }
    return duration_options;
  }

  async submit() {
    try {
      await this.formState.validate();
      await this.surveyState.validate();
      if (!this.surveyState.hasErrors && !this.formState.hasErrors()) {
        const surveyKey = this.surveyState.hasSurvey ? this.surveyState.surveyKey : null;
        await this.submitState.operate(async () => {
          await this.formState.submitAsJson((subscriptionSuspension) =>
            SubscriptionsApis.suspend(this.subscriptionCode, {
              ...subscriptionSuspension,
              survey_answers: {
                survey_key: surveyKey,
                parameters: this.surveyState.parameters,
                answers: this.surveyState.questionAnswers,
              },
            })
          );
          this.routerState.push(V3Routes.subscriptionSuspended(this.subscriptionCode));
        });
      }
    } catch (e) {
      alert('休会申請に失敗しました: ' + translateErrorMessage(e));
    }
  }
}
